module.exports = __webpack_public_path__ + "img/panda-drm-advance.50cbb889.png";